
import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

import { getDataValueFromElement } from '@utils';
const currentEnvironment = getDataValueFromElement(
  'meta_data',
  'data-current-environment',
);

if (currentEnvironment === 'prod' || currentEnvironment === 'staging') {
  Sentry.init({
    dsn: 'https://e271944935ce4a0f8bcb792b61dc8e3d@o154234.ingest.sentry.io/1429241',
    environment: currentEnvironment,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
    release: 'distillery-frontend',
  });
}

import './authy';

// Images live in static_src/public/ and are copied verbatim into the build
// output by Vite's publicDir handling (they used to be imported here purely
// so webpack would copy them).
